import { PAYMENT_METHOD_CATEGORY } from 'utils/paymentMethodConstants';

export const SHIFT_DETAIL_PAYMENT_METHOD_CATEGORY_CONFIG = {
  [PAYMENT_METHOD_CATEGORY.INTEGRATION]: {
    expectedField: 'expected_integration_payment',
  },
  [PAYMENT_METHOD_CATEGORY.E_WALLET]: {
    expectedField: 'expected_ewallet_payment',
  },
  [PAYMENT_METHOD_CATEGORY.CARD]: {
    refundField: 'total_voided',
    expectedField: 'expected_card_payment',
  },
  [PAYMENT_METHOD_CATEGORY.EDC]: {
    refundField: 'total_edc_refunds',
    expectedField: 'expected_edc_payment',
  },
  [PAYMENT_METHOD_CATEGORY.OTHER]: {
    refundField: 'other_refunds',
    expectedField: 'expected_other_payment',
  },
};
